var React = require('react');

function DeviceRoutersIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.625 5.78a7.004 7.004 0 0 1 8.75 0 1 1 0 0 0 1.25-1.56 9.004 9.004 0 0 0-11.25 0 1 1 0 1 0 1.25 1.56zm6.668 2.927a3.243 3.243 0 0 0-4.586 0 1 1 0 1 1-1.414-1.414 5.243 5.243 0 0 1 7.414 0 1 1 0 0 1-1.414 1.414zM18 10a1 1 0 1 0-2 0v2H4a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3h-2v-2zm-1 4H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-3zm.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM14 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z","fill":"#E8EFFF"}));
}

DeviceRoutersIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DeviceRoutersIcon;

DeviceRoutersIcon.default = DeviceRoutersIcon;
